import React from 'react'
import { observer } from 'mobx-react-lite'
import MediaUploaderButton from './../../../../components/modals/MediaUploaderModal/button.component'
import { MDBIcon } from 'mdb-react-ui-kit'

import './UploadEliteAgencyTeamLogoButton.scss'

export default observer(({ EliteAgencyTeam }) => {
  if (EliteAgencyTeam?.id()) {
    return (
      <MediaUploaderButton
        block
        label={
          <>
            Upload Elite Agency Team Logo &nbsp;
            <MDBIcon icon='plus' />
          </>
        }
        modalConfig={{
          uploadType: 'elite_agency_team_logo',
          modalContentTop: (
            <div className='text--center fw--500'>
              <h6 className='fw--500'>Upload Elite Agency Team Logo.</h6>
            </div>
          ),
          appendFormData: { elite_agency_team_id: EliteAgencyTeam.id() },
          validationRules: { contentType: ['image/png'] },
        }}
        onSuccess={filepath => EliteAgencyTeam.set('team_logo', filepath)}
      />
    )
  }

  return <></>
})
